/**
 * Style File — Quality Control screen. One of the 7 process screens reached
 * from Overview's "Work on this style" rail (`style-overview-page.tsx`).
 *
 * @see docs/product/garment-os-screen-build-plan.md §A
 */
import { Alert } from "@flint/ui";
import { trpc } from "../../../lib/trpc.js";
import type { StyleStatus } from "../lib/status.js";
import { StyleCockpitChrome, SectionCard } from "./style-cockpit-chrome.js";
import { QcSection } from "./qc-section.js";

export function StyleQcPage({ styleId }: { styleId: string }) {
  const query = trpc.styles.get.useQuery({ id: styleId });

  if (query.isLoading) return <p className="p-6 text-sm text-muted">Loading…</p>;
  if (query.error || !query.data) {
    return (
      <div className="p-6">
        <Alert intent="bad" title="Couldn't load style file" description={query.error?.message ?? "Not found."} />
      </div>
    );
  }

  const style = query.data;
  const status = style.status as StyleStatus;
  const meta =
    status === "in_production" || status === "shipped" || status === "closed"
      ? "End-line AQL 2.5 · defect log · DHU"
      : "Opens once in production";

  return (
    <StyleCockpitChrome styleId={styleId} style={style}>
      <SectionCard title="Quality Control" meta={meta} id="sec-qc">
        <QcSection styleId={styleId} styleStatus={status} />
      </SectionCard>
    </StyleCockpitChrome>
  );
}
